import * as React from 'react';

import { GameTileProps, GameClickProps } from '../types';
import { Ghost } from '../Banner';
import { CallbackMode } from '../../../logic/main/types';
import { BIG_OUTFIT } from '../constants';
import BannerComponent from '../Banner/BannerComponent';

interface BannerProps {
  topSlot?: GameTileProps;
  onClick?: (
    game: GameClickProps,
    e?: React.MouseEvent<HTMLAnchorElement>
  ) => void;
  onInfoClick?: (
    game: GameClickProps,
    path: string,
    e?: React.MouseEvent<HTMLAnchorElement>
  ) => void;
  ghost?: boolean;
  gameDetailsInfo?: boolean;
  callbackMode: CallbackMode;
  isAnchor?: boolean;
}

const Banner: React.FC<BannerProps> = ({
  topSlot,
  onClick,
  onInfoClick,
  ghost,
  gameDetailsInfo,
  callbackMode,
  isAnchor = true,
}) => {
  if (!topSlot && ghost) {
    return <Ghost />;
  }
  if (!topSlot) {
    return null;
  }

  const {
    banner,
    launchUrl,
    gameDetailsPath,
    bannerImage,
    table,
    notIndexed,
  } = topSlot;

  const info = {
    visible: gameDetailsInfo,
    onClick: () => onInfoClick && onInfoClick(topSlot, topSlot.gameDetailsPath),
  };

  const anchorLayer = {
    visible: !!(isAnchor && launchUrl),
    url: launchUrl,
    gameDetailsPath,
    target: '_blank',
    onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (callbackMode === 'event') e.preventDefault();
      onClick && onClick(topSlot, e);
    },
    notIndexed,
  };
  const sashLayer = topSlot.sash && {
    sash: topSlot.sash.title,
    background: topSlot.sash.background,
    outfit: BIG_OUTFIT,
  };

  return (
    <BannerComponent
      ghost={ghost}
      asset={bannerImage ? bannerImage : banner}
      info={info}
      anchorLayer={anchorLayer}
      sashLayer={sashLayer}
      tableLayer={table}
      jackpotLayer={topSlot.jackpot}
      gameBannerTitle={topSlot.title}
    />
  );
};

export default Banner;
